import { createApi, fetchBaseQuery, } from "@reduxjs/toolkit/query/react";
import { secureBaseQuery } from "./secureBaseQuery.js";
import {dynamicBaseQuery} from "./dynamicBaseQuery.js";
import { api } from "../../Appjs/api.js";

export const customerApi = createApi({
  reducerPath: "customerApi",
  baseQuery: fetchBaseQuery({
    baseUrl: api,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
    //  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
 fetchCustomers: builder.query({
  query: ({ page = 1, limit = 10 }) => ({
    url: `/reseller/get-reseller-intro-by?page=${page}&limit=${limit}`,
    method: "GET",
  }),
}),
    createCustomer: builder.mutation({
      query: (newCustomer) => ({
        url: "/reseller/create-customer",
        method: "POST",
        body: newCustomer,
      }),
    }),
    createReseller: builder.mutation({
      query: (newReseller) => ({
        url: "/reseller/create-reseller-profile",
        method: "POST",
        body: newReseller,
      }),
    }),
    editReseller: builder.mutation({
      query: (updatedReseller) => ({
        url: "/reseller/edit-reseller-profile",
        method: "PUT",
        body: updatedReseller,
      }),
    }),
  }),
});

export const {
  useFetchCustomersQuery,
  useCreateCustomerMutation,
  useCreateResellerMutation,
  useEditResellerMutation,
} = customerApi;
